import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ClassToggleService, HeaderComponent } from '@coreui/angular-pro';

import { OkAloneService } from '../../../ok-alone.service';
import { Router } from '@angular/router';

import { TranslocoService } from '@ngneat/transloco';

declare var window: any;

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent {

  @Input() sidebarId: string = "sidebar1";

  public newMessages = new Array(4)
  public newTasks = new Array(5)
  public newNotifications = new Array(5)

  public themeSwitch = new UntypedFormGroup({
    themeSwitchRadio: new UntypedFormControl('light'),
  });


  constructor(private classToggler: ClassToggleService, private router: Router, public okService:OkAloneService, public translocoService: TranslocoService) {
    super();
  }

  setTheme(value: string): void {
    this.themeSwitch.setValue({ themeSwitchRadio: value });
    this.classToggler.toggle('body', 'dark-theme');
  }


  doLogout(){

    //console.log("Logout ");

    this.okService.logoutToken();
    this.okService.logout();
    if(localStorage.getItem('is_adp')){
      localStorage.removeItem('is_adp');

      let url="https://accounts.adp.com/auth/oauth/v2/logout?post_logout_redirect_uri=https%3A%2F%2Fmy.okalone.net";

      window.location.href = url;

    }else{
      this.router.navigateByUrl('/login');
    }



    return false;

  }

  setLang(lang:any){
    this.okService.langChoice = lang;
    this.okService.setLangChoice();
    //console.log('setlangChoice',this.okService.langChoice);
  }

  getNewsId(){
    
    return this.okService.news[0].id;
    
  }


  goToNews(news:any){

    if(news.type=="dashboard"){
      this.router.navigateByUrl(news.link);
    }else{
      window.open(news.link, '_blank').focus();
    }
  }

  switchAccount(accountId: number){
    // Find the login with the matching id
    const selectedLogin = this.okService.me.other_logins.find((login: any) => login.id === accountId);
    
    if (selectedLogin && selectedLogin.token) {
      // Reload the page with the ul parameter
      window.location.href = window.location.origin + window.location.pathname + '?ul=' + selectedLogin.token;
    }
  }
}
